import { render, staticRenderFns } from "./skeletonSlider.vue?vue&type=template&id=b297c91e&scoped=true"
var script = {}
import style0 from "./skeletonSlider.vue?vue&type=style&index=0&id=b297c91e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b297c91e",
  null
  
)

export default component.exports